import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { DeprecatedTextAreaAutosize } from '../../primitives/deprecated-text-area-autosize/text-area-autosize';
/** @deprecated please use \<FormControl/> */
var DeprecatedFormTextArea = /** @class */ (function (_super) {
    __extends(DeprecatedFormTextArea, _super);
    function DeprecatedFormTextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeprecatedFormTextArea.prototype.render = function () {
        var invalid = !!this.props.validationError;
        var classNames = namespacedClassnames('deprecated-form-text-area', this.props.className, { invalid: invalid });
        var maybeInvalidMsg = invalid ? (React.createElement("div", { className: 'validation-msg' }, this.props.validationError)) : null;
        return this.props.label ? (React.createElement("label", { className: classNames },
            React.createElement("span", { className: 'label-text' }, this.props.label),
            React.createElement(DeprecatedTextAreaAutosize, __assign({}, this.props, { validationError: this.props.validationError })),
            maybeInvalidMsg)) : (React.createElement("span", { className: classNames },
            React.createElement(DeprecatedTextAreaAutosize, __assign({}, this.props, { validationError: this.props.validationError })),
            maybeInvalidMsg));
    };
    return DeprecatedFormTextArea;
}(React.PureComponent));
export { DeprecatedFormTextArea };
//# sourceMappingURL=index.js.map